import { Box, Flex, Text } from '@chakra-ui/react';
import { map, isEmpty, take } from 'lodash/fp';
import { useAppStore } from '@halo/chat-sdk-react';
import type { SearchHistroyItemType } from '@halo/chat-sdk-react';
import { ConfirmDialog } from '@halo/ui-chat-react';
import DeleteIcon from '@/assets/images/common/svg/del.svg?react';
import { SearchTabs } from './helpers';

export default function SearchHistory({
  onSearch,
  active,
}: {
  onSearch: (val: string) => void;
  active: SearchTabs;
}) {
  const { t } = useTranslation();
  const [histories, setHistories] = useState<SearchHistroyItemType[]>([]);
  const { client } = useAppStore();
  const [open, setOpen] = useState(false);

  const getHistory = useDebounceFn(async () => {
    const res = await client?.Api.common.searchHistory();
    setHistories(res?.history ?? []);
  });

  const delHistory = async () => {
    await client?.Api.common.delSearchHistory();
    setHistories([]);
    setOpen(false);
  };

  useEffect(() => {
    if (active === SearchTabs.TopResults) {
      getHistory.run();
    }
  }, [active]);

  if (isEmpty(histories)) {
    return null;
  }

  return (
    <Box>
      <Flex h={8} alignItems="center" justifyContent="space-between">
        <Text fontSize="xs" color="fg.muted" fontWeight="medium">
          {t('filter.searchHistory')}
        </Text>
        <DeleteIcon style={{ cursor: 'pointer' }} onClick={() => setOpen(true)} />
      </Flex>

      <Flex gap="10px" flexWrap="wrap">
        {map(
          (item) => (
            <HistoryItem key={item?.id} value={item?.keyword} onClick={onSearch} />
          ),
          take(10, histories) as SearchHistroyItemType[]
        )}
      </Flex>

      <ConfirmDialog
        contentProps={{ w: '428px' }}
        open={open}
        onClose={() => setOpen(false)}
        title={t('filter.deleteAllSearchHistory')}
        onOk={delHistory}
      ></ConfirmDialog>
    </Box>
  );
}

function HistoryItem({ value, onClick }: { value: string; onClick: (val: string) => void }) {
  return (
    <Box
      display="flex"
      alignItems="center"
      px="2"
      h={7}
      rounded="xl"
      bg="border"
      cursor="pointer"
      onClick={() => onClick(value)}
      maxW="full"
    >
      <Text fontSize="xs" truncate w="100%">
        {value}
      </Text>
    </Box>
  );
}
